import React, { useCallback, useEffect, useState } from 'react';
import api from '../../services/api';
import { notificaErrore, notificaConferma, messaggioDa } from '../../utils/notifiche';

/**
 * RiquadroLavoro — le aziende di cui il paziente e' lavoratore, con le date
 * (medicina del lavoro, proposta 18, migration 266).
 *
 * E' il legame che permette di fatturare all'azienda le visite di medicina
 * del lavoro fatte in quel periodo. Lo scrivono amministrazione e segreteria;
 * lo leggono tutti. Non si cancella: si chiude con la data di fine, cosi' le
 * fatture gia' fatte restano spiegabili.
 */
const dataIta = (v) => {
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(v || ''));
    return m ? `${m[3]}/${m[2]}/${m[1]}` : '';
};

const RiquadroLavoro = ({ pazienteId, ruolo }) => {
    const scrive = ruolo === 'admin' || ruolo === 'segreteria';
    const [datori, setDatori] = useState(null);
    const [nuovo, setNuovo] = useState(null);       // { cerca, trovate, soggetto_id, dal, al }
    const [inCorso, setInCorso] = useState(false);

    const carica = useCallback(async () => {
        try {
            const r = await api.get(`/pazienti/${pazienteId}/datori`);
            setDatori(r.data?.data?.datori || []);
        } catch (e) { setDatori([]); }
    }, [pazienteId]);
    useEffect(() => { carica(); }, [carica]);

    const cercaAzienda = async (testo) => {
        setNuovo((n) => ({ ...n, cerca: testo, soggetto_id: '' }));
        if (testo.trim().length < 2) { setNuovo((n) => ({ ...n, trovate: [] })); return; }
        try {
            const r = await api.get('/fatturazione/soggetti', { params: { q: testo.trim(), tipo: 'azienda' } });
            const d = r.data?.data;
            setNuovo((n) => ({ ...n, trovate: (Array.isArray(d) ? d : (d?.soggetti || [])).slice(0, 10) }));
        } catch (e) { setNuovo((n) => ({ ...n, trovate: [] })); }
    };

    const salva = async () => {
        setInCorso(true);
        try {
            const r = await api.post(`/pazienti/${pazienteId}/datori`,
                { soggetto_id: nuovo.soggetto_id, dal: nuovo.dal, al: nuovo.al || undefined });
            notificaConferma(r.data?.message || 'Collegato.');
            setNuovo(null);
            carica();
        } catch (e) {
            notificaErrore(messaggioDa(e, 'Non riesco a collegare il lavoratore'));
        } finally { setInCorso(false); }
    };

    const chiudi = async (d) => {
        const al = window.prompt('Ultimo giorno di lavoro per questa azienda (aaaa-mm-gg)');
        if (!al) return;
        try {
            await api.put(`/pazienti/datori/${d.id}`, { al: al.trim() });
            carica();
        } catch (e) {
            notificaErrore(messaggioDa(e, 'Non riesco a chiudere il collegamento'));
        }
    };

    if (datori === null) return null;
    if (!datori.length && !scrive) return null;
    return (
        <div className="sp-row sp-row-blocco">
            <span className="sp-row-label">Lavoro</span>
            <div className="sp-row-valore">
                {!datori.length && <span className="sp-vuoto-nota">Nessuna azienda: serve solo per la medicina del lavoro</span>}
                {datori.map((d) => (
                    <div key={d.id} className="sp-designata">
                        <b>{d.denominazione}</b>
                        <span className="sp-designata-rel">
                            dal {dataIta(d.dal)}{d.al ? ` al ${dataIta(d.al)}` : ''}
                        </span>
                        {scrive && !d.al && (
                            <button type="button" className="sp-link-lavoro" onClick={() => chiudi(d)}>Chiudi</button>
                        )}
                    </div>
                ))}
                {scrive && !nuovo && (
                    <button type="button" className="sp-link-lavoro"
                            onClick={() => setNuovo({ cerca: '', trovate: [], soggetto_id: '', dal: '', al: '' })}>
                        + Collega a un&apos;azienda
                    </button>
                )}
                {scrive && nuovo && (
                    <div className="sp-lavoro-nuovo">
                        <input placeholder="Cerca l'azienda…" value={nuovo.cerca} aria-label="Cerca l'azienda"
                               onChange={(e) => cercaAzienda(e.target.value)} />
                        {!nuovo.soggetto_id && nuovo.trovate.length > 0 && (
                            <ul>
                                {nuovo.trovate.map((s) => (
                                    <li key={s.id}>
                                        <button type="button" onClick={() => setNuovo((n) => ({ ...n, soggetto_id: s.id, cerca: s.denominazione, trovate: [] }))}>
                                            {s.denominazione}
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        )}
                        <label>dal <input type="date" value={nuovo.dal} onChange={(e) => setNuovo((n) => ({ ...n, dal: e.target.value }))} /></label>
                        <label>al <input type="date" value={nuovo.al} onChange={(e) => setNuovo((n) => ({ ...n, al: e.target.value }))} /></label>
                        <button type="button" className="sp-link-lavoro" disabled={inCorso || !nuovo.soggetto_id || !nuovo.dal} onClick={salva}>
                            Collega
                        </button>
                        <button type="button" className="sp-link-lavoro" onClick={() => setNuovo(null)}>Annulla</button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default RiquadroLavoro;
